import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Utils/store";

import ProtectedRoute from "./components/auth/ProtectedRoute";

// Components and Pages
import Sidebar from "./components/others/Sidebar";
import Appointments from "./pages/Appointments";
import LogIn from "./pages/auth/LogIn";
import SignUp from "./pages/auth/SignUp";
import WelcomePage from "./pages/auth/WelcomePage";
import RegistrationDone from "./pages/auth/RegistrationDone";
import Dashboard from "./pages/Dashboard";
import EmailConfirmed from "./pages/auth/EmailConfirmed";
import LostPage from "./pages/Lost";
import Patients from "./pages/Patients";
import NewPatient from "./components/patient/forms/NewPatient";
import PatientReport from "./components/patient/PatientReport";
import PatientDetails from "./components/patient/PatientDetails";
import Prescription from "./pages/Prescriptions";
import NewPrescription from "./components/prescription/NewPrescription";
import Report from "./components/prescription/PrescriptionReport";
// import PartnersSettings from "./components/settings/PartnerSettings";
// import PaymentSettings from "./components/settings/PaymentSettings";
// import ProfileSettings from "./components/settings/ProfileSettings";
import CreateNewAppointment from "./pages/CreateNewAppointment";
import AppointmentReport from "./components/appointments/AppointmentReport";
import Billing from "./pages/Billing";
import AllInvoices from "./pages/AllInvoices";
import ServiceInvoice from "./components/billings/forms/ServiceInvoice";
import InventoryInvoice from "./components/billings/forms/InventoryInvoice";
import Partners from "./pages/Partners";
import PartnersDetails from "./components/partners/PartnersDetails";
import PartnersReport from "./components/partners/PartnersReport";
import NewPartner from "./pages/NewPartner";
import Inventory from "./pages/Inventory";
import InventoryReport from "./components/inventory/InventoryReport";
import NewInventory from "./components/inventory/NewInventory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/authProvider";

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ToastContainer />
        <Router>
          {/* Public Routes */}
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/login" element={<LogIn notify={toast} />} />
            <Route path="/signup" element={<SignUp notify={toast} />} />
            <Route path="/registered" element={<RegistrationDone />} />
            <Route path="/email_verified" element={<EmailConfirmed />} />
            <Route path="*" element={<LostPage />} />
          </Routes>

          {/* Protected Routes */}
          <Sidebar>
            <Routes>
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/patients"
                element={
                  <ProtectedRoute>
                    <Patients notify={toast} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/patients/new-patient"
                element={
                  <ProtectedRoute>
                    <NewPatient />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/patients/patient-report"
                element={
                  <ProtectedRoute>
                    <PatientReport notify={toast} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/patients/details"
                element={
                  <ProtectedRoute>
                    <PatientDetails notify={toast} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/prescription"
                element={
                  <ProtectedRoute>
                    <Prescription notify={toast} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/prescription/new_prescription"
                element={
                  <ProtectedRoute>
                    <NewPrescription notify={toast} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/prescription/all_prescription"
                element={
                  <ProtectedRoute>
                    <Report notify={toast} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/appointments"
                element={
                  <ProtectedRoute>
                    <Appointments />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/appointments/appointment-report"
                element={
                  <ProtectedRoute>
                    <AppointmentReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/appointments/new-appointment"
                element={
                  <ProtectedRoute>
                    <CreateNewAppointment />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/billings"
                element={
                  <ProtectedRoute>
                    <Billing />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/billings/all_invoices"
                element={
                  <ProtectedRoute>
                    <AllInvoices />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/billings/inventory_invoice"
                element={
                  <ProtectedRoute>
                    <InventoryInvoice />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/billings/service_invoice"
                element={
                  <ProtectedRoute>
                    <ServiceInvoice />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inventory"
                element={
                  <ProtectedRoute>
                    <Inventory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inventory/all_inventories"
                element={
                  <ProtectedRoute>
                    <InventoryReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inventory/new_inventory"
                element={
                  <ProtectedRoute>
                    <NewInventory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/partners"
                element={
                  <ProtectedRoute>
                    <Partners />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/partners/partner-report"
                element={
                  <ProtectedRoute>
                    <PartnersReport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/partners/new-partner"
                element={
                  <ProtectedRoute>
                    <NewPartner />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/partners/details"
                element={
                  <ProtectedRoute>
                    <PartnersDetails />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Sidebar>
        </Router>
      </AuthProvider>
    </Provider>
  );
}

export default App;
